function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { mapState } from 'vuex';
import dtwinApi from '@/services/apiService/digitalTwin';
import debounce from 'lodash/debounce';
import _get from 'lodash/get';
export default {
  name: 'TwinFilterEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      twinSearchString: '',
      parentTwinSearchString: '',
      isSearchingTwins: false,
      isSearchingParentTwins: false,
      twinSearchItems: [],
      parentTwinSearchItems: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), mapState('dashboards', ['dashboards'])), {}, {
    dashboard: function dashboard() {
      var _this = this;
      return this.dashboards.find(function (dashboard) {
        return dashboard.id === _this.dashboardId;
      });
    },
    tags: {
      get: function get() {
        var tags = _get(this.value, 'tags', []);
        if (!Array.isArray(tags)) {
          return [];
        }
        return tags;
      },
      set: function set(val) {
        this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, {
          tags: val
        }));
      }
    },
    selectionForParentTwinsInput: function selectionForParentTwinsInput() {
      var parentTwinIds = _get(this.value, 'parentDtwinIds', []);
      return [].concat(_toConsumableArray(this.parentTwinSearchItems), _toConsumableArray(this.dashboardParametersAsSelectItems)).filter(function (item) {
        return parentTwinIds.includes(String(item.value));
      }).filter(function (item, index, self) {
        return self.findIndex(function (t) {
          return t.value === item.value;
        }) === index;
      });
    },
    selectionForTwinsInput: function selectionForTwinsInput() {
      var twinIds = _get(this.value, 'ids', []);
      return [].concat(_toConsumableArray(this.twinSearchItems), _toConsumableArray(this.dashboardParametersAsSelectItems)).filter(function (item) {
        return twinIds.includes(String(item.value));
      }).filter(function (item, index, self) {
        return self.findIndex(function (t) {
          return t.value === item.value;
        }) === index;
      });
    },
    dashboardParametersAsSelectItems: function dashboardParametersAsSelectItems() {
      return Object.keys(this.customParameters).map(function (key) {
        return {
          value: "{{".concat(key, "}}"),
          text: "{{".concat(key, "}}")
        };
      });
    }
  }),
  watch: {
    twinSearchString: {
      handler: function handler() {
        this.searchTwins();
      },
      immediate: true
    },
    'value.ids': {
      handler: function handler() {
        this.searchTwins();
      },
      immediate: true
    },
    parentTwinSearchString: {
      handler: function handler() {
        this.searchParentTwins();
      },
      immediate: true
    },
    'value.parentDtwinIds': {
      handler: function handler() {
        this.searchParentTwins();
      },
      immediate: true
    }
  },
  methods: {
    setByKey: function setByKey(key, val) {
      var clone = cloneDeep(this.value);
      if (key === 'tag') {
        val = val || undefined;
      }
      set(clone, key, val);
      this.$emit('input', clone);
    },
    searchParentTwins: debounce(function () {
      this.actuallySearchTwins('parents');
    }, 500),
    searchTwins: debounce(function () {
      this.actuallySearchTwins('twins');
    }, 500),
    _fetchTwinsBySearchString: function _fetchTwinsBySearchString(searchString) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var twins, dashboardTenantId, result, _recursiveAddTwinToTwins;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              twins = [];
              dashboardTenantId = _get(_this2.dashboard, 'identifier.tenantId', undefined);
              if (dashboardTenantId) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", twins);
            case 4:
              _context.next = 6;
              return dtwinApi.digitalTwinFetchPartialTree(_this2, undefined, searchString, undefined, ['bare'], dashboardTenantId);
            case 6:
              result = _context.sent;
              _recursiveAddTwinToTwins = function recursiveAddTwinToTwins(twin) {
                twins.push(_objectSpread(_objectSpread({}, twin), {}, {
                  children: undefined
                }));
                if (Array.isArray(twin.children)) {
                  twin.children.forEach(function (child) {
                    _recursiveAddTwinToTwins(child);
                  });
                }
              };
              result.digitaltwins.forEach(function (twin) {
                _recursiveAddTwinToTwins(twin);
              });
              return _context.abrupt("return", twins);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    actuallySearchParentTwins: function actuallySearchParentTwins() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var twins, searchString, dashboardTenantId, dashboardParentTwinId, result, _addToTwins, searchItems, previouslySelectedParentTwinIds, _yield$dtwinApi$digit, previouslySelectedParentTwins;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isSearchingParentTwins = true;
              twins = [];
              searchString = _this3.parentTwinSearchString;
              if (!((searchString || '').length > 3)) {
                _context2.next = 14;
                break;
              }
              _context2.t0 = twins.push;
              _context2.t1 = twins;
              _context2.t2 = _toConsumableArray;
              _context2.next = 9;
              return _this3._fetchTwinsBySearchString(searchString);
            case 9:
              _context2.t3 = _context2.sent;
              _context2.t4 = (0, _context2.t2)(_context2.t3);
              _context2.t0.apply.call(_context2.t0, _context2.t1, _context2.t4);
              _context2.next = 23;
              break;
            case 14:
              dashboardTenantId = _get(_this3.dashboard, 'identifier.tenantId');
              dashboardParentTwinId = _get(_this3.dashboard, 'meta.parentDtwinId');
              if (!(!dashboardTenantId || !dashboardParentTwinId)) {
                _context2.next = 18;
                break;
              }
              return _context2.abrupt("return", twins);
            case 18:
              _context2.next = 20;
              return dtwinApi.digitalTwinFetchPartialTree(_this3, dashboardParentTwinId, undefined, undefined, ['bare'], dashboardTenantId);
            case 20:
              result = _context2.sent;
              _addToTwins = function addToTwins(twin) {
                twins.push(twin);
                if (Array.isArray(twin.children)) {
                  twin.children.forEach(function (child) {
                    _addToTwins(child);
                  });
                }
              };
              result.digitaltwins.forEach(function (twin) {
                _addToTwins(twin);
              });
            case 23:
              searchItems = [].concat(_toConsumableArray(_this3.dashboardParametersAsSelectItems), _toConsumableArray(twins.map(function (twin) {
                return {
                  value: twin.id,
                  text: twin.title
                };
              })));
              previouslySelectedParentTwinIds = _get(_this3.value, 'parentDtwinIds', []).map(Number).filter(function (val) {
                return !isNaN(val);
              });
              if (!(previouslySelectedParentTwinIds.length > 0)) {
                _context2.next = 31;
                break;
              }
              _context2.next = 28;
              return dtwinApi.digitalTwinsFetch(_this3, null, [], [{
                type: 'dtwinIds',
                ids: previouslySelectedParentTwinIds
              }]);
            case 28:
              _yield$dtwinApi$digit = _context2.sent;
              previouslySelectedParentTwins = _yield$dtwinApi$digit.digitaltwins;
              searchItems.push.apply(searchItems, _toConsumableArray(previouslySelectedParentTwins.map(function (twin) {
                return {
                  value: twin.id,
                  text: twin.title
                };
              })));
            case 31:
              _this3.parentTwinSearchItems = searchItems;
            case 32:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    actuallySearchNonParentTwins: function actuallySearchNonParentTwins() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var twins, searchString, dashboardTenantId, dashboardParentTwinId, result, _addToTwins2, searchItems, previouslySelectedTwinIds, _yield$dtwinApi$digit2, previouslySelectedTwins;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isSearchingTwins = true;
              twins = [];
              searchString = _this4.twinSearchString;
              if (!((searchString || '').length > 3)) {
                _context3.next = 14;
                break;
              }
              _context3.t0 = twins.push;
              _context3.t1 = twins;
              _context3.t2 = _toConsumableArray;
              _context3.next = 9;
              return _this4._fetchTwinsBySearchString(searchString);
            case 9:
              _context3.t3 = _context3.sent;
              _context3.t4 = (0, _context3.t2)(_context3.t3);
              _context3.t0.apply.call(_context3.t0, _context3.t1, _context3.t4);
              _context3.next = 23;
              break;
            case 14:
              dashboardTenantId = _get(_this4.dashboard, 'identifier.tenantId');
              dashboardParentTwinId = _get(_this4.dashboard, 'meta.parentDtwinId');
              if (!(!dashboardTenantId || !dashboardParentTwinId)) {
                _context3.next = 18;
                break;
              }
              return _context3.abrupt("return", twins);
            case 18:
              _context3.next = 20;
              return dtwinApi.digitalTwinFetchPartialTree(_this4, dashboardParentTwinId, undefined, undefined, ['bare'], dashboardTenantId);
            case 20:
              result = _context3.sent;
              _addToTwins2 = function addToTwins(twin) {
                twins.push(twin);
                if (Array.isArray(twin.children)) {
                  twin.children.forEach(function (child) {
                    _addToTwins2(child);
                  });
                }
              };
              result.digitaltwins.forEach(function (twin) {
                _addToTwins2(twin);
              });
            case 23:
              searchItems = [].concat(_toConsumableArray(_this4.dashboardParametersAsSelectItems), _toConsumableArray(twins.map(function (twin) {
                return {
                  value: twin.id,
                  text: twin.title
                };
              })));
              previouslySelectedTwinIds = _get(_this4.value, 'ids', []).map(Number).filter(function (val) {
                return !isNaN(val);
              });
              if (!(previouslySelectedTwinIds.length > 0)) {
                _context3.next = 31;
                break;
              }
              _context3.next = 28;
              return dtwinApi.digitalTwinsFetch(_this4, null, [], [{
                type: 'dtwinIds',
                ids: previouslySelectedTwinIds
              }]);
            case 28:
              _yield$dtwinApi$digit2 = _context3.sent;
              previouslySelectedTwins = _yield$dtwinApi$digit2.digitaltwins;
              searchItems.push.apply(searchItems, _toConsumableArray(previouslySelectedTwins.map(function (twin) {
                return {
                  value: twin.id,
                  text: twin.title
                };
              })));
            case 31:
              _this4.twinSearchItems = searchItems;
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    actuallySearchTwins: function actuallySearchTwins(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!(type === 'parents')) {
                _context4.next = 6;
                break;
              }
              _context4.next = 4;
              return _this5.actuallySearchParentTwins();
            case 4:
              _context4.next = 9;
              break;
            case 6:
              if (!(type === 'twins')) {
                _context4.next = 9;
                break;
              }
              _context4.next = 9;
              return _this5.actuallySearchNonParentTwins();
            case 9:
              _context4.next = 15;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
              _this5.$snack(_this5.$t('Dashboards.components.twinFilterEditor.snack.error.couldNotFetchTwins', {
                error: _context4.t0.message
              }), 'error');
            case 15:
              _context4.prev = 15;
              if (type === 'parents') {
                _this5.isSearchingParentTwins = false;
              } else if (type === 'twins') {
                _this5.isSearchingTwins = false;
              }
              return _context4.finish(15);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11, 15, 18]]);
      }))();
    },
    setParentTwinSelection: function setParentTwinSelection(val) {
      var clone = cloneDeep(val);
      this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, {
        parentDtwinIds: clone.map(String)
      }));
    },
    setTwinSelection: function setTwinSelection(val) {
      var clone = cloneDeep(val);
      this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, {
        ids: clone.map(String)
      }));
    }
  }
};